export const api = {
  token: "8c13c3eacb1530899c5cfec398667f",
  url: "https://api.vitamin-d.live/",
  assets: "https://api.vitamin-d.live/storage/uploads",
  download: "https://api.vitamin-d.live/download.php?file=",
  thumbs:
    "https://api.vitamin-d.live/api/cockpit/image?token=8c13c3eacb1530899c5cfec398667f&rspc=1&w=400&m=fitToHeight&q=86&o=1&src=/storage/uploads",
};
